import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import EditProfileSection from './EditProfileSection';
import ChangePasswordSection from './ChangePasswordSection';
import MyOrdersPage from './MyOrdersPage';
import ApiSettingsSection from './ApiSettingsSection';
import CreditLedgerSection from './CreditLedgerSection';

const TabLink = ({ to, label }) => (
  <NavLink
    to={to}
    style={({ isActive }) => ({
      padding: '8px 12px',
      borderRadius: 8,
      fontSize: 14,
      fontWeight: 600,
      color: isActive ? '#7c3aed' : 'var(--color-text-muted)',
      backgroundColor: isActive ? '#f3e8ff' : 'transparent',
      border: isActive ? '1px solid #e9d5ff' : '1px solid transparent',
      textDecoration: 'none'
    })}
  >
    {label}
  </NavLink>
);

const SettingsPage = () => {
  const location = useLocation();

  const path = location.pathname;
  const isProfile = path.endsWith('/profile');
  const isPassword = path.endsWith('/password');
  const isOrders = path.endsWith('/orders');
  const isAPI = path.endsWith('/api');
  const isCreditLedger = path.endsWith('/credit-ledger');

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Settings</h1>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <TabLink to="/dashboard/settings/profile" label="Edit Profile" />
        <TabLink to="/dashboard/settings/password" label="Change Password" />
        <TabLink to="/dashboard/settings/orders" label="My Orders" />
        <TabLink to="/dashboard/settings/credit-ledger" label="Credit Ledger" />
        <TabLink to="/dashboard/settings/api" label="API" />
      </div>

      <div style={{ background: '#fff', border: '1px solid var(--color-border)', borderRadius: 12, padding: 16 }}>
        {isProfile && <EditProfileSection />}
        {isPassword && <ChangePasswordSection />}
        {isOrders && <MyOrdersPage embedded />}
        {isCreditLedger && <CreditLedgerSection />}
        {isAPI && <ApiSettingsSection />}
      </div>
    </div>
  );
};

export default SettingsPage;